/**
 * StripeApp API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  stripeAppAuthorize,
  stripeAppConnect,
  stripeAppCreateInvoice,
  stripeAppDisconnect,
  stripeAppEntityDisconnect,
  stripeAppEntityGetConnection,
  stripeAppEntityGetSettings,
  stripeAppEntityUpdateSettings,
  stripeAppGetConnection,
  stripeAppGetInvoice,
  stripeAppGetSettings,
  stripeAppListInvoices,
  stripeAppLookupInvoice,
  stripeAppMarketplaceAuthorize,
  stripeAppOAuthCallback,
  stripeAppUpdateSettings,
  stripeAppWebhook,
} from "../generated/stripe-app/stripe-app";

import { wrapMethod } from "./utils";

export const stripeApp = {
  /** @see stripeAppAuthorize */
  stripeAppAuthorize: wrapMethod(stripeAppAuthorize),

  /** @see stripeAppOAuthCallback */
  stripeAppOAuthCallback: wrapMethod(stripeAppOAuthCallback),

  /** @see stripeAppWebhook */
  stripeAppWebhook: wrapMethod(stripeAppWebhook),

  /** @see stripeAppMarketplaceAuthorize */
  stripeAppMarketplaceAuthorize: wrapMethod(stripeAppMarketplaceAuthorize),

  /** @see stripeAppConnect */
  stripeAppConnect: wrapMethod(stripeAppConnect),

  /** @see stripeAppGetConnection */
  stripeAppGetConnection: wrapMethod(stripeAppGetConnection),

  /** @see stripeAppDisconnect */
  stripeAppDisconnect: wrapMethod(stripeAppDisconnect),

  /** @see stripeAppGetSettings */
  stripeAppGetSettings: wrapMethod(stripeAppGetSettings),

  /** @see stripeAppUpdateSettings */
  stripeAppUpdateSettings: wrapMethod(stripeAppUpdateSettings),

  /** @see stripeAppCreateInvoice */
  stripeAppCreateInvoice: wrapMethod(stripeAppCreateInvoice),

  /** @see stripeAppListInvoices */
  stripeAppListInvoices: wrapMethod(stripeAppListInvoices),

  /** @see stripeAppLookupInvoice */
  stripeAppLookupInvoice: wrapMethod(stripeAppLookupInvoice),

  /** @see stripeAppGetInvoice */
  stripeAppGetInvoice: wrapMethod(stripeAppGetInvoice),

  /** @see stripeAppEntityGetConnection */
  stripeAppEntityGetConnection: wrapMethod(stripeAppEntityGetConnection),

  /** @see stripeAppEntityDisconnect */
  stripeAppEntityDisconnect: wrapMethod(stripeAppEntityDisconnect),

  /** @see stripeAppEntityGetSettings */
  stripeAppEntityGetSettings: wrapMethod(stripeAppEntityGetSettings),

  /** @see stripeAppEntityUpdateSettings */
  stripeAppEntityUpdateSettings: wrapMethod(stripeAppEntityUpdateSettings),
} as const;

export type StripeAppApi = typeof stripeApp;
